import { Injectable, inject } from '@angular/core';
import { GeneralProjectService } from '@app/cem/project/services/general-project.service';
import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from '@app/shared/aggrid/pxd-ag-grid-options';
import { PxdAgGridSelectEditorComponent } from '@app/shared/aggrid/pxd-ag-grid-select-editor';
import { DefaultProjectTeam } from 'app/shared/models';

export interface DefaultTeamRig {
  RigId?: number;
  DefaultRigId?: number;
  DefaultProjectTeamId?: number;
  Name: string;
}

export class ProjectTeamRigsGridOptions implements PxdAgGridOptions {
  enableCharts = true;
  cellSelection = true;
  rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  editType: 'fullRow' = 'fullRow';
  defaultColDef = PxdAgEditGridDefaultColumnDef;
  statusBar = PxdAgGridStatusBarOptions;
  sideBar = PxdAgGridSideBarOptions;
  columnTypes = PxdAgGridColumnTypes;
  columnDefs = [];
}

@Injectable({
  providedIn: 'root'
})
export class ProjectTeamRigsGridOptionsService {
  public generalProjectService = inject(GeneralProjectService);

  public projectTeamRigsGridOptions: ProjectTeamRigsGridOptions = new ProjectTeamRigsGridOptions();

  public constructor() {
    this.projectTeamRigsGridOptions.columnDefs = this.columnDefs;
  }
  DefaultProjectTeams: Map<number, DefaultProjectTeam> = new Map();

  getDefaultProjectTeam = (id) => {
    if (!id) return '';
    let dteam = this.DefaultProjectTeams.get(id);
    if (dteam) return dteam.Description;
    return '';
  }

  columnDefs = [
    { field: 'RigId', editable: false },
    { field: 'Name', headerName: 'Rig Name', editable: false },
    {
      field: 'DefaultProjectTeamId', headerName: 'Default Project Team',
      cellRenderer: params => {
        return this.getDefaultProjectTeam(params.value);
      },
      cellEditorSelector: params => {
        return {
          component: PxdAgGridSelectEditorComponent,
          params: {
            values: Array.from(this.DefaultProjectTeams.values()).map(d => {
              return { value: d.DefaultProjectTeamId, text: d.Description };
            })
          }
        };
      }
    }
  ];
}